import axios from "axios";

const API_BASE = (process.env.REACT_APP_BACKEND || '').replace(/\/$/, '');

const Dashboard = {
  // 取得儀表板
  GetByCompanyId: async (companyId) => {
    try {
      const response = await axios.get(`${API_BASE}/api/companies/${companyId}/dashboard`);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.error || "取得儀表板失敗");
    } catch (error) {
      console.error("GetByCompanyId Error:", error);
      throw error;
    }
  },

  // 建立儀表板
  Create: async (companyId, data) => {
    try {
      const response = await axios.post(`${API_BASE}/api/companies/${companyId}/dashboard`, data);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.error || "建立儀表板失敗");
    } catch (error) {
      console.error("Create Error:", error);
      throw error;
    }
  },

  // 更新儀表板
  Update: async (companyId, data) => {
    try {
      const response = await axios.put(`${API_BASE}/api/companies/${companyId}/dashboard`, data);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.error || "更新儀表板失敗");
    } catch (error) {
      console.error("Update Error:", error);
      throw error;
    }
  },

  // 刪除儀表板
  Delete: async (companyId) => {
    try {
      const response = await axios.delete(`${API_BASE}/api/companies/${companyId}/dashboard`);
      if (response.data.success) {
        return true;
      }
      throw new Error(response.data.error || "刪除儀表板失敗");
    } catch (error) {
      console.error("Delete Error:", error);
      throw error;
    }
  },

  // 取得場域的機具清單
  GetFieldMachines: async (fieldId) => {
    try {
      const response = await axios.get(`${API_BASE}/api/fields/${fieldId}/machines`);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.error || "取得機具清單失敗");
    } catch (error) {
      console.error("GetFieldMachines Error:", error);
      throw error;
    }
  },

  // 取得機具的參數清單
  GetMachineParameters: async (fieldMobileId) => {
    try {
      const response = await axios.get(`${API_BASE}/api/machines/${fieldMobileId}/parameters`);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.error || "取得參數清單失敗");
    } catch (error) {
      console.error("GetMachineParameters Error:", error);
      throw error;
    }
  },

  // 取得機具某參數的歷史時序資料
  GetMachineHistory: async (fieldMobileId, parameterKey, limit = 60, startDate = null, endDate = null) => {
    try {
      const params = { key: parameterKey, limit };
      if (startDate) params.start_date = startDate;
      if (endDate) params.end_date = endDate;
      
      const response = await axios.get(`${API_BASE}/api/machines/${fieldMobileId}/history`, {
        params,
      });
      if (response.data.success) {
        return response.data.data;
      }
      return [];
    } catch (error) {
      console.error(`GetMachineHistory Error (${fieldMobileId}, ${parameterKey}):`, error);
      return [];
    }
  },

  // ✨ 新增：一次取得場域所有機具的 function 資料
  GetFieldMobilesFunctions: async (fieldId) => {
    try {
      const response = await axios.get(`${API_BASE}/api/fields/${fieldId}/mobiles/functions`);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.error || "取得機具資料失敗");
    } catch (error) {
      console.error("GetFieldMobilesFunctions Error:", error);
      throw error;
    }
  },

  // 檢查是否存在
  CheckExists: async (companyId) => {
    try {
      const response = await axios.get(`${API_BASE}/api/companies/${companyId}/dashboard/exists`);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error(response.data.error || "檢查失敗");
    } catch (error) {
      console.error("CheckExists Error:", error);
      throw error;
    }
  },

};

export default Dashboard;
